<template>
  <div style="position: relative;">
    <!-- {{ model.next_stop }} -->
    <!-- schema: {{ schema }} -->
    <!-- parentModel {{ parentModel }} -->

    <!-- defaultTab:{{ defaultTab }} mainTab:{{ mainTab }} -->
    <!-- mainTabs {{ mainTabs }} -->
    <!-- service_hours: {{ model.service_hours }} -->
    <!-- <router-view class="active-view">
      <object-on-demand />
    </router-view> -->
    <!-- model:{{ model }} -->
    <v-form-tool-bar
      :toolBarControls="toolBarControls"
      :toolbarRight="toolbarRight"
      :customBtnLoading="customBtnLoading"
      :customBtnClick="customBtnClick"
      v-if="toolBarControls"
    ></v-form-tool-bar>

    <v-tabs v-if="isTab() && Object.keys(schema).length > 1" v-model="tab">
      <v-tab v-for="(value, key) in schema" :key="key">
        {{ value["title"] }}
      </v-tab>
    </v-tabs>

    <v-tabs
      class="main-tabs class mt-n2 mb-2"
      v-if="mainTabsClone && mainTabsClone.length && !parentKey"
      v-model="mainTab"
    >
      <template v-for="(value, i) in mainTabsClone">
        <v-tab @click="changeTab ? changeTab(i) : ''" v-if="displayIf(value, parentKey, key) && !value.hidden" :key="i">
          {{ value["tabName"] }}
        </v-tab>
      </template>
    </v-tabs>
    <v-card v-if="steppers && steppers.length">
      <v-stepper non-linear flat v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > i" :editable="step > i" :step="i + 1" v-for="(s, i) in steppers" :key="i">
            {{ capitalize(s.name) }}
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper></v-card
    >
    <div class="mb-8" v-if="steppers && steppers.length" />
    <component :is="getParentComponent()" v-if="displayParent()" ref="parentComponent" v-model="tab" :key="topKey">
      <div hidden>
        {{ parentObject }}
        <v-text-field />
        <v-textarea />
        <v-switch />
        <v-col />
        <v-lazy />
        <v-range-slider />
        <v-radio-list />
        <v-checkbox-list />
      </div>
      <!-- {{ addCollectionToSchema() }} -->

      <component
        :key="key"
        :ref="key"
        :is="isTab() ? `v-tab-item` : 'v-col'"
        :sm="
          value &&
          value[`cols`] &&
          showColumns(value, key, schema) &&
          show(value, key) &&
          displayIf(value, parentKey, key)
            ? value && value[`cols`]
            : 0
        "
        :cols="
          fullCol
            ? '12'
            : value && !value[`cols`]
            ? '12'
            : !show(value, key) || !displayIf(value, parentKey, key)
            ? 0
            : $vuetify.breakpoint.smAndDown
            ? '12'
            : value[`cols`] || 12
        "
        :class="
          !show(value, key) || !displayIf(value, parentKey, keys)
            ? ''
            : (isTab() || inLine) && $vuetify.breakpoint.mdAndUp
            ? 'ml-n4  col'
            : $vuetify.breakpoint.mdAndUp
            ? 'mt-0 mb-2 ml-0 mr-0 pa-0 col'
            : 'ml-n1 pl-2 pr-2 col'
        "
        :style="!show(value, key) || !displayIf(value, parentKey, key) ? 'display:none !important' : ''"
        v-for="(value, key) in addCollectionToSchema"
      >
        <!-- {{ value["x-display"] }}
        {{ value["model"] }} -->
        <!-- {{ value }} -->
        <!-- key:{{ key }}
        {{show(value, key) && displayIf(value, parentKey, key)}} -->
        <!-- key:{{ key }} value:{{ value }} -->
        <component
          :is="noLazy ? 'div' : `v-lazy`"
          v-model="isActive"
          :options="{
            threshold: 0.5
          }"
          transition="fade-transition"
        >
          <component
            :style="cssstyle ? cssstyle : value['drawer'] ? 'width:' + value['width'] : 'width:100%'"
            flat
            absolute
            :right="value['right']"
            temporary
            v-model="drawer[key]"
            :elevation="value[`elevation`]"
            :is="value[`panel`] ? 'v-expansion-panel' : value['drawer'] ? 'v-navigation-drawer' : `div`"
            :class="
              value[`hideChildTitle`]
                ? 'ml-3'
                : value[`card`]
                ? 'ma-2 pa-2'
                : value['drawer']
                ? 'pa-2'
                : isTab()
                ? 'ml-0'
                : 'mt-0 mb-0 pa-0'
            "
            v-if="show(value, key) && displayIf(value, parentKey, key)"
          >
            <component
              :is="value['panel'] && !value['hideHeader'] ? 'v-expansion-panel-header' : 'div'"
              style="width: 100%"
              :class="
                value['panel']
                  ? $vuetify.breakpoint.mdAndUp
                    ? 'ml-0 mb-n2 mt-n2'
                    : 'ml-n6 mr-0 mb-n2 mt-n2 '
                  : $vuetify.breakpoint.mdAndUp
                  ? ''
                  : 'mt-0 ml-4 pa-0'
              "
              v-if="
                value[`title`] &&
                  (value[`type`] == `object` || value['panel']) &&
                  (!value[`hideTitle`] || value['panel']) &&
                  ((value[`label_type`] != `menu_button` && !value['hideHeader']) ||
                    (value['panel'] && !value['hideHeader']))
              "
            >
              <h3 v-if="!hideTitle" class="ml-4 pt-4 text--lighten-3">
                {{ value["title"] }}
              </h3>
              <template v-if="hideTitle" v-slot:default="{ open }">
                <h3 class="ml-4 text--lighten-3">
                  {{ value["title"] }}
                </h3>
                <v-toolbar flat>
                  <v-icon large class="ml-n2 mr-2 mt-2" v-if="value['headerIcon']">
                    {{ value["headerIcon"] }}
                  </v-icon>

                  <v-toolbar-title class="mb-n4 mt-n4" v-if="value['title']">
                    <h4 class="mt-2" :class="value['panel'] ? 'underscore' : ''" small>
                      <div v-if="open || !value['displayOnClosedHeader']">
                        {{ value["title"] }}
                      </div>
                      <div v-if="!open && value['displayOnClosedHeader']">
                        {{ calculateTitle(value["displayOnClosedHeader"], key) }}
                      </div>
                    </h4>
                  </v-toolbar-title>
                  <v-spacer />

                  <v-btn @click.stop="closeDrawer(key)" text v-if="value['drawer']">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-toolbar class="ma-n4" flat small>
                  <v-spacer></v-spacer>
                  <v-chip v-if="value['chipProperty']" color="white">
                    {{ model[value["chipProperty"]] }}
                  </v-chip>
                </v-toolbar>
              </template>
            </component>

            <component
              :class="$vuetify.breakpoint.mdAndUp ? 'pa-2' : ''"
              :is="value[`panel`] ? 'v-expansion-panel-content' : value[`tabs`] ? 'v-tab-item' : 'div'"
            >
              <component
                :is="
                  (value[`card`] || (value[`v-bind`] && value['v-bind']['card'])) && $vuetify.breakpoint.mdAndUp
                    ? 'v-card'
                    : 'div'
                "
                :flat="value[`flat`]"
                :elevation="value[`elevation`]"
                :class="
                  value[`card`] && $vuetify.breakpoint.mdAndUp
                    ? value['draggable']
                      ? 'ml-n2 pl-4 pt-0 pb-4 draggable ' + key + ' ' + parentKey
                      : 'ml-n2 pl-4 pt-0'
                    : value['draggable']
                    ? 'draggable ' + key + ' ' + parentKey
                    : ''
                "
              >
                <h3 class="ml-6" v-if="(value[`type`] == `object` && !value[`hideTitle`]) || value[`panel`]"></h3>
                <div v-if="value[`panel_content`]" v-html="value[`panel_content`]"></div>

                <v-row
                  :class="{
                    'ml-0': $vuetify.breakpoint.smAndDown
                  }"
                >
                  <!-- key_obj:{{ value["key_obj"] }} -->
                  <v-toolbar
                    :class="value['draggable'] ? 'ml-n2 mr-n2 drag-header' : 'mb-n2 mt-n3'"
                    :dark="value['draggable']"
                    :color="value['headerColor'] ? getColor(value['headerColor'], key) : ''"
                    flat
                    v-if="
                      value[`label_type`] == `menu_button` && !isTab() && !value['panel'] && !value['noLabelButton']
                    "
                  >
                    <v-label-button
                      :schema="value"
                      :color="value['draggable'] ? '' : 'primary'"
                      :data_key="value[`data_key`]"
                      :model_key="value[`key`]"
                      :v-model="parModel"
                      :parSchema="schema"
                      :hideChildTitle="value[`hideChildTitle`]"
                      :k="key"
                      :add_option_object="value[`add_option_object`]"
                    />

                    <v-move-button v-if="value[`draggable`]" :k="key" :move="move" :schema="schema" />

                    <v-delete-button v-if="value[`canDelete`]" :k="key" :deleteRec="deleteRec" />
                  </v-toolbar>

                  <v-spacer v-if="value[`total_title`] && hasTabs && model[key][Object.keys(model[key])[tabs]]" />

                  <v-chip
                    elevation-10
                    :class="{
                      'mt-2': $vuetify.breakpoint.smAndDown,
                      'mr-2': $vuetify.breakpoint.mdAndUp
                    }"
                    v-if="value[`total_title`] && hasTabs && model[key][Object.keys(model[key])[tabs]]"
                  >
                    <h3 class="ma-2">
                      {{ value[`total_title`] }}:
                      {{
                        isNaN(parseFloat(model[key][Object.keys(model[key])[tabs]][value[`total_field`]]).toFixed(2))
                          ? "0.00"
                          : parseFloat(model[key][Object.keys(model[key])[tabs]][value[`total_field`]]).toFixed(2)
                      }}
                    </h3>
                  </v-chip>
                </v-row>
                <!-- linked_object:{{ value.linked_object }} -->

                <v-linked-object
                  v-bind="value['linked_object']"
                  :v-bind="value['linked_object']"
                  :formModel="model"
                  :model="linkedSearchModel"
                  :hasModel="getLinkedId(key)"
                  v-model="linkedSearch"
                  v-if="value['linked_object'] && !linkedSearchModel"
                ></v-linked-object>

                <div
                  :key="key"
                  v-if="!value['linked_object'] || linkedSearch || (value['linked_object'] && linkedSearchModel)"
                >
                  <!-- key: {{ key }} model: {{ model }} x-display: -->
                  <!-- {{ value["x-display"] }} -->
                  <v-row
                    v-if="displayComponent(value, parentKey, key)"
                    :class="
                      value[`panel`] ||
                      value['directEdit'] ||
                      value[`x-display`] == 'd-table' ||
                      value[`x-display`] == 'v-charge' ||
                      value[`x-display`] == 'v-labor' ||
                      value[`x-display`] == 'd-iterator' ||
                      value[`x-display`] == 'v-data-time-line' ||
                      value[`x-display`] == 'v-collapsible'
                        ? $vuetify.breakpoint.smAndDown
                          ? 'ml-0 mr-0'
                          : 'ml-2'
                        : $vuetify.breakpoint.smAndDown
                        ? 'pl-4 pr-4  ml-0 '
                        : 'pl-0 ml-0 mt-0'
                    "
                  >
                    <div v-if="(value['type'] != 'object' || value['x-display']) && editMode">
                      {{
                        value[`hideTitle`]
                          ? ""
                          : value["calculatedTitle"]
                          ? calculateTitle(value["calculatedTitle"])
                          : value[`title`]
                      }}:
                      <b>{{ model[key] }}</b>
                    </div>
                    <!-- <v-edit-dialog
                      v-if="
                        (value['type'] != 'object' || value['x-display']) &&
                        !editMode &&
                        value['x-display'] != 'v-btn'
                      "
                      v-model="dialogModel"
                    >
                      <v-row>
                        <v-col class="mb-n2" cols="12"
                          ><span class="value-title">
                            {{
                              value[`hideTitle`]
                                ? ""
                                : value["calculatedTitle"]
                                ? calculateTitle(value["calculatedTitle"])
                                : value[`title`]
                            }}
                          </span></v-col
                        >
                        <v-col class="mt-n4" cols="12"
                          ><span class="value-text">{{ model[key] }}</span></v-col
                        >
                      </v-row>

                      <template v-slot:input> -->
                    <!-- <template v-if="value['x-display'] == 'object-on-demand'">
                      here is my on demand component
                      <span v-if="false"></span>
                    </template> -->
                    <component
                      :key="componentKey"
                      :ref="key"
                      :required="value[`required`] || required"
                      :rules="getRule(value[`rules`], value[`title`]) || rules"
                      :is="value['x-display'] || `v-text-field`"
                      v-if="
                        (value['type'] != 'object' || value['x-display']) && !editMode && value['x-display'] != 'v-btn'
                      "
                      :type="value['x-type'] || `text`"
                      :class="
                        value[`class`]
                          ? value[`class`]
                          : value[`x-display`] == 'd-table' ||
                            value[`x-display`] == 'v-data-time-line' ||
                            value[`x-display`] == 'd-iterator'
                          ? $vuetify.breakpoint.smAndDown
                            ? 'ml-0'
                            : 'ml-0 mr-n4 pa-0'
                          : value[`x-display`] == 'v-switch'
                          ? 'mt-2'
                          : 'pl-2 mr-6'
                      "
                      :style="
                        value['style'] || value[`full-width`] != false
                          ? value[`description`]
                            ? 'width:80% !important'
                            : 'width:100% !important'
                          : value[`x-display`] == `v-date-field` ||
                            value[`x-display`] == `v-time-field` ||
                            value[`x-display`] == `v-datetime-picker`
                          ? '200px !important'
                          : value[`x-display`] != `v-address` &&
                            value[`x-display`] != `v-accordion` &&
                            value[`v-switch`] != `v-accordion` &&
                            value[`full-width`] != true
                          ? !value[`hideTitle`]
                            ? 'max-width:240px !important'
                            : 'max-width:240px !important; margin-top:-18px !important'
                          : $vuetify.breakpoint.mdAndU
                          ? 'max-width:95%'
                          : ''
                      "
                      :k="key"
                      :objectName="data_object ? data_object.objectName : ''"
                      :onValueChange="onValueChange"
                      :onLoadComponent="onLoadComponent"
                      :data_object="
                        value[`x-display`] == 'd-table' ||
                        value[`x-display`] == 'v-data-time-line' ||
                        value[`x-display`] == 'd-iterator'
                          ? schema[key]['table_properties']
                          : schema[key]
                      "
                      :schema="schema"
                      :prepend-icon="value[`prependIcon`]"
                      :label="
                        value[`hideTitle`]
                          ? ''
                          : value['calculatedTitle']
                          ? calculateTitle(value['calculatedTitle'])
                          : value[`title`]
                      "
                      v-model="model[key]"
                      :v-model="
                        model[key]
                          ? model[key]
                          : value[`x-display`] == 'd-table' ||
                            value[`x-display`] == 'v-charge' ||
                            value[`x-display`] == 'd-iterator' ||
                            value[`x-display`] == 'v-data-time-line' ||
                            value[`x-display`] == 'v-collapsible'
                          ? []
                          : {}
                      "
                      :outlined="value[`outlined`]"
                      :dense="true"
                      :inLine="inLine"
                      :isExpandRow="isExpandRow"
                      :formModel="model"
                      :parentModel="data_object && data_object.parentModel ? data_object.parentModel : parentModel"
                      :v-bind="getVBind(value)"
                      v-bind="getVBind(value)"
                      :parentSchema="parentSchema"
                      :parentKey="parentKey"
                      :newKey="value[`newKey`]"
                      :parModel="parModel"
                      :parObject="parObject"
                      :parentObject="parentObject"
                      v-on:blur="onBlur(key)"
                      v-on:input="getInput(key, value[`onValueChange`], 'input')"
                      v-on:change="getInput(key, value[`onValueChange`], 'change')"
                      @click:append="getInput(key, value[`v-bind`][`onAppendClick`], 'appendClick')"
                      @click:clear="getInput(key, value[`onValueChange`], 'clear')"
                      :on="value['on']"
                      :placeholder="placeholder"
                      :readonly="getReadOnly(key)"
                      :additionalModel="additionalModel"
                      :changeTab="changeTab"
                    ></component>
                    <!-- </template>
                    </v-edit-dialog> -->
                    <v-btn
                      :color="value['v-bind'].color"
                      :text="value['v-bind'].text"
                      :disabled="value['v-bind']['disabled'] ? getVal(value['v-bind']['disabled']) : false"
                      v-if="value[`x-display`] == 'v-btn' && !value[`hidden`]"
                      @click="customBtnClick(value, key)"
                    >
                      <v-icon v-if="value['v-bind'].icon">
                        {{ value["v-bind"].icon }}
                      </v-icon>

                      {{
                        value["v-bind"]["template"]
                          ? getVal(value["v-bind"]["template"])
                          : value["v-bind"]["input-value"]
                      }}
                    </v-btn>

                    <component :is="value[`description`] ? 'v-col' : 'div'" v-if="value[`description`]">
                      <v-tooltip
                        :max-width="checkWidth()"
                        offset-overflow
                        v-if="value[`description`]"
                        :open-on-hover="false"
                        :open-on-click="true"
                        left
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn right @click="on.click" icon v-if="displayComponent(value, parentKey, key)">
                            <v-icon color="info">mdi-help-circle</v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:default>
                          <span v-html="value[`description`]" style="pointer-events: initial; "> </span>
                        </template>
                      </v-tooltip>
                    </component>
                  </v-row>
                  <div v-if="loading && !parentSchema" class="blur-overlay">
                    <h2 class="ma-2">
                      Schema is updating (it may take more than a minute)
                    </h2>
                    <v-progress-circular indeterminate color="primary" size="60" width="6"></v-progress-circular>
                  </div>
                  <div class="schema-container" :class="{ blurred: loading }">
                    <v-form-component
                      v-if="
                        value[`x-display`] != 'd-table' &&
                          value[`x-display`] != 'd-iterator' &&
                          value[`x-display`] != 'v-data-time-line' &&
                          value[`x-display`] != 'v-collapsible' &&
                          value[`properties`] &&
                          (!optional || (model && Object.keys(model).length && model[Object.keys(model)[0]])) &&
                          (displayComponent(value, parentKey, key) || !value[`v-if-parameter`])
                      "
                      :key="componentKeyChild"
                      :drawerModel="drawerModel"
                      :model="getModel(key)"
                      :parModel="model"
                      :parentModel="parentModel"
                      :parentSchemaObject="parentSchemaObject"
                      :parentKey="key"
                      :newKey="newKey"
                      :parentSchema="parentSchema ? parentSchema : schema"
                      :parObject="parentObject"
                      :onLoadComponent="onLoadComponent"
                      :isChild="true"
                      :inLine="inLine"
                      :noCache="noCache"
                      :isExpandRow="isExpandRow"
                      :submit="submit"
                      :optional="parentShow(key, parentKey, schema)"
                      :schema="value[`properties`]"
                      :data_object="data_object"
                      :cssstyle="value[`cssstyle`]"
                      :card="value[`card`]"
                      :draggable="value[`draggable`]"
                      :required="value[`required`]"
                      :displayOnClosedHeader="value[`displayOnClosedHeader`]"
                      :rules="getRule(value[`rules`], value[`title`])"
                      v-bind="getVBind(value)"
                      :v-bind="getVBind(value)"
                      :click="click"
                      :onValueChange="onValueChange"
                      :additionalModel="additionalModel"
                      :mainTabs="mainTabsClone"
                      :mainTab="mainTab"
                      :keepTab="keepTab"
                      :noMainTabs="noMainTabs"
                      :sortedKey="sortedKey"
                      :changeTab="changeTab"
                      :defaultModel="defaultModel"
                      :hasParent="hasParent"
                      :fullCol="fullCol"
                    ></v-form-component>
                  </div>
                  <!-- schema:{{ schema }} -->
                  <v-btn
                    v-if="schema[key] && canEditForm && !noEditForm && $vuetify.breakpoint.lgAndUp"
                    @click="editDialog = true"
                    text
                    color="warning"
                    class="edit-form-btn"
                  >
                    <v-icon left>mdi-table-edit</v-icon>
                  </v-btn>
                  <v-dialog v-model="editDialog" width="500">
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Add/Edit Fields
                      </v-card-title>

                      <v-card-text>
                        <schema-tree
                          ref="schemaTree"
                          :schema="editSchema"
                          :schemaTabs="schemaTabs"
                          @add-field="onAddField"
                          @edit-field="onEditField"
                          @hide-field="onHideField"
                          @combo-updated="onComboUpdated"
                          @move-field="onMoveField"
                        />
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="success"
                          text
                          @click="
                            editDialog = false;
                            updateSchema();
                          "
                        >
                          Update Form
                        </v-btn>
                        <v-btn
                          color="warning"
                          text
                          @click="
                            editDialog = false;
                            updateSchema(true);
                          "
                        >
                          Revert to Original Fields
                        </v-btn>
                        <v-btn text @click="editDialog = false">
                          Cancel
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-add-button
                    v-if="
                      value[`can_add`] &&
                        value[`x-display`] != 'd-iterator' &&
                        value[`x-display`] != 'v-collapsible' &&
                        (displayComponent(value, parentKey, key) || !value[`v-if-parameter`])
                    "
                    :schema="value"
                    :addRec="addRec"
                    :k="key"
                  />
                </div>
              </component>
            </component>
          </component>
        </component>
      </component>
    </component>

    <v-stepper
      non-linear
      style="height: 90px; background-color: transparent"
      class="footer"
      v-if="steppers && steppers.length"
      v-model="step"
    >
      <v-stepper-items class="ma-2">
        <v-stepper-content class="mb-n8" v-for="(s, i) in steppers" :key="i" :step="i + 1">
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn text v-if="step > 1" @click="step = step - 1"> Back </v-btn>
            <v-btn text class="info" ref="stepSubmit" @click="stepSubmit(i)">
              {{ s.btn.caption }}
            </v-btn>
          </v-toolbar>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import draggable from "vuedraggable";
import debounce from "lodash/debounce";
import axios from "axios";
export default {
  name: "v-form-component",
  components: {
    draggable,
    VFormComponent: () => import("./FormComponent.vue"),
    VAddress: () => import("./Address.vue"),
    VDateField: () => import("./DateField.vue"),
    VTimeField: () => import("./TimeField.vue"),
    VDateTime: () => import("./DateTime.vue"),
    VCombo: () => import("./ComboBox.vue"),
    VComboTable: () => import("./ComboTable.vue"),
    VAddButton: () => import("./AddButton.vue"),
    VDeleteButton: () => import("./DeleteButton.vue"),
    VMoveButton: () => import("./MoveButton.vue"),
    AddToTable: () => import("./AddToTable.vue"),
    VAccordion: () => import("./Accordion.vue"),
    VLabelButton: () => import("./LabelButton.vue"),
    VLabel: () => import("./Label.vue"),
    DList: () => import("../components/List.vue"),
    DIterator: () => import("../components/Iterator.vue"),
    DTable: () => import("../components/Table.vue"),
    VDateRangePicker: () => import("../components/DateRangePicker.vue"),
    USMap: () => import("../components/USMap.vue"),
    VCountriesMap: () => import("../components/CountriesMap.vue"),
    VRadioList: () => import("../components/RadioList.vue"),
    VCheckboxList: () => import("../components/CheckBoxList.vue"),
    VPanels: () => import("../components/Panels.vue"),
    VUnitCharge: () => import("../components/UnitCharge.vue"),
    VTreeInput: () => import("../components/TreeInput.vue"),
    VSelectedReportFields: () => import("../components/SelectedReportFields.vue"),
    VEditor: () => import("../components/Editor.vue"),
    SendLetter: () => import("../components/SendLetter.vue"),
    WeekDays: () => import("../components/WeekDays.vue"),
    DaysOfMonth: () => import("../components/DaysOfMonth.vue"),
    VRate: () => import("../components/Rate.vue"),
    VLabor: () => import("../components/Labor.vue"),
    VColorField: () => import("../components/ColorField.vue"),
    VCollapsible: () => import("../components/Collapsible.vue"),
    VPresetTable: () => import("../components/PresetTable.vue"),
    VUpload: () => import("../components/UploadDragDrop.vue"),
    VLinkedObject: () => import("./LinkedObject.vue"),
    VAvailabilitySearch: () => import("../components/AvailabilitySearch.vue"),
    VImage: () => import("../components/Image.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VDocument: () => import("../components/Document.vue"),
    VFormToolBar: () => import("../components/FormToolBar.vue"),
    VDialogTable: () => import("../components/DialogTable.vue"),
    VDataTimeLine: () => import("../components/DataTimeLine.vue"),
    VRange: () => import("../components/Range.vue"),
    VNumberPicker: () => import("../components/NumberPicker.vue"),
    VCc: () => import("../components/CC.vue"),
    vAchBank: () => import("../components/AchBank.vue"),
    VCrew: () => import("../components/Crew.vue"),
    VLinkInput: () => import("../components/LinkInput.vue"),
    VAvailability: () => import("../components/Availability.vue"),
    VTakePhoto: () => import("../components/TakePhoto.vue"),
    VArray: () => import("../components/Array.vue"),
    VPhone: () => import("../components/Phone.vue"),
    VLetterBody: () => import("../components/LetterBody.vue"),
    VSmsBody: () => import("../components/SMSBody.vue"),
    VCustomerInventory: () => import("../components/dashboard/CustomerInventory.vue"),
    VDragDropList: () => import("../components/DragDropList.vue"),
    SchemaTree: () => import("../components/SchemaTree.vue"),
    VTimeWindow: () => import("../components/TimeWindow.vue"),
    VTimePicker: () => import("../components/TimePicker.vue"),
    VEmailList: () => import("../components/EmailList.vue"),
    VVolumeCalculator: () => import("../components/VolumeCalculator.vue"),
    VSections: () => import("../components/Sections.vue"),
    ObjectOnDemand: () => import("../components/ObjectOnDemand.vue"),
    ComponentOnDemand: () => import("../components/ComponentOnDemand.vue"),
    VQtyInput: () => import("../components/QtyInput.vue"),
    VNumberField: () => import("../components/NumberField.vue")
  },
  data: () => ({
    items: [],
    componentKey: 1,
    componentKeyChild: 0,
    newKey: "",
    showInfo: [],
    tab: 0,
    data: 0,
    isActive: false,
    drawer: {},
    drawerChanged: false,
    readonly: false,
    draggedEl: null,
    parentEl: null,
    positions: {},
    l: 0,
    topKey: 0,
    editMode: 0,
    linkedSearchModel: 0,
    linkedSearch: true,
    test: false,
    settings: false,
    permittedKeys: JSON.parse(localStorage.getItem("permittedKeys")),
    permissions: null,
    path: "",
    mainTabsReady: false,
    tabChanging: false,
    isFormComponent: true,
    step: 1,
    defaultTab: null,
    dialogModel: false,
    editDialog: false,
    addedFields: [],
    editedFields: [],
    hiddenFields: [],
    movedFields: [],
    comboUpdates: [],
    loading: false,
    canEditForm: false,
    openedObjectOnDemand: false
  }),
  props: {
    model: {
      type: [Object, Array, String, Number],
      default: () => ({}) // ✅ always defined
    },
    parentModel: [Object, Array],
    schema: Object,
    doSubmit: Boolean,
    submit: Function,
    parObject: [Object, Array],
    topModel: [Object, Array],
    parentKey: String,
    parentSchema: Object,
    parentSchemaObject: Object,
    onLoadComponent: Function,
    parModel: [Object, Array],
    optional: Boolean,
    isChild: Boolean,
    hasTabs: Boolean,
    tabs: Number,
    hssTabs: Boolean,
    cssstyle: String,
    data_object: Object,
    rules: Array,
    required: [Boolean, String, Array],
    drawerModel: Object,
    inLine: Boolean,
    isExpandRow: Boolean,
    placeholder: String,
    click: Function,
    onValueChange: Function,
    noLazy: Boolean,
    additionalModel: Object,
    toolBarControls: Array,
    defaultModel: [Object, Array],
    toolbarRight: Boolean,
    customBtnLoading: Boolean,
    mainTabs: Array,
    mainTab: {
      type: Number,
      default: 0
    },
    keepTab: Boolean,
    getMainTabs: Function,
    noMainTabs: Boolean,
    changeTab: Function,
    sortedKey: Boolean,
    steppers: Array,
    hasParent: Boolean,
    noCache: Boolean,
    topObject: String,
    noEditForm: Boolean,
    fullCol: Boolean,
    fields_excluded: Array,
    fields_included: Array
  },
  // beforeUpdate() {
  //   console.log("Before update model:", this.model);
  // },
  methods: {
    onAddField({ parent, field, display, after, cols, title, tab }) {
      if (!field) {
        return;
      }
      const parentName = parent || this.key; // same fallback

      this.addedFields.push({
        parent: parentName,
        field,
        display,
        after,
        cols,
        title,
        tab
      });
    },
    onEditField({ parent, name, title, display, after, cols, tab }) {
      const parentName = parent || this.key;

      let existing = this.editedFields.find(f => f.name === name);
      if (existing) {
        existing.title = title;
        existing.display = display;
        existing.after = after;
        existing.cols = cols;
        existing.tab = tab;
      } else {
        this.editedFields.push({
          parent: parentName,
          name,
          title,
          display,
          after,
          cols,
          tab: tab
        });
      }

      // If the field was newly added and then edited:
      let added = this.addedFields.find(f => f.field === name);
      if (added) {
        added.title = title;
        added.display = display;
        added.after = after;
        added.cols = cols;
        added.tab = tab;
      }
    },
    onHideField({ parent, name }) {
      const parentName = parent || this.key;

      this.hiddenFields.push({
        parent: parentName,
        name
      });
    },

    onComboUpdated({ parent, field, items }) {
      const parentName = parent || this.key;

      let existing = this.comboUpdates.find(f => f.field === field);
      if (existing) {
        existing.items = items;
      } else {
        this.comboUpdates.push({
          parent: parentName,
          field,
          items
        });
      }
    },
    // onMoveField({ parent, name, after }) {
    //   const parentName = parent || this.key;

    //   let existing = this.movedFields.find(f => f.name === name);
    //   if (existing) {
    //     existing.after = after;
    //   } else {
    //     this.movedFields.push({
    //       parent: parentName,
    //       name,
    //       after
    //     });
    //   }

    //   // If new field was moved
    //   let added = this.addedFields.find(f => f.field === name);
    //   if (added) {
    //     added.after = after;
    //   }

    //   // If edited field was moved
    //   let edited = this.editedFields?.find(f => f.name === name);
    //   if (edited) {
    //     edited.after = after;
    //   }
    // },
    getVal(val) {
      return eval(val);
    },
    restoreSchema() {
      var that = this;
      if (this.hasParent) {
        return;
      }
      if (!this.parentKey) {
        let objName = this.data_object?.objectName;
        if (objName) {
          let origSchema = JSON.parse(localStorage.getItem(objName));
          Object.keys(this.schema).forEach(k => {
            delete this.schema[k];
            console.log(that.schema);
          });
          Object.keys(origSchema).forEach(k => {
            this.schema[k] = origSchema[k];
          });
        }
      }
    },
    stepSubmit(i) {
      if (this.step == this.steppers.length) {
        if (this.submit({ steppers: true })) {
          this.$root.$emit("stepsCompleted", {
            obj: this,
            step: i
          });
        }
      } else {
        if (this.submit({ steppers: true })) {
          this.step += 1;
        }
      }
    },
    updateDefaultModel() {
      var that = this;
      var defaultProperties = fun.getObjects(this.schema, "defaultProperty", true);
      if (defaultProperties.length) {
        defaultProperties.forEach(p => {
          var model = that.model[p.parent_key];
          if (model) {
            var parModel = "";

            Object.keys(model).forEach(k => {
              parModel = model[k];
              if (typeof parModel != "object" && !parModel[p.key]) {
                model[k] = {};
                model[k][p.key] = parModel;
              }
            });
          }
        });
      }
      var curModel = this.model;
      Object.keys(this.schema).forEach(k => {
        if (this.schema[k] && this.schema[k].default) {
          if (!this.model[k]) {
            try {
              if (!this.schema[k].defaultIf || eval(this.schema[k].defaultIf)) {
                this.model[k] = this.schema[k].default;
              } else {
                this.model[k] = this.schema[k].defaultAlt;
              }
            } catch (error) {
              //
            }
          }
        }
      });
    },
    buildMovedFieldsFromOrder(schemaProps, parentName) {
      if (!schemaProps || typeof schemaProps !== "object") return [];

      const entries = Object.entries(schemaProps)
        .filter(([_, field]) => field && !field.hidden)
        .sort((a, b) => (a[1]._order ?? 0) - (b[1]._order ?? 0));

      const result = [];

      entries.forEach(([key, field], index) => {
        result.push({
          parent: parentName,
          name: key,
          after: index === 0 ? null : entries[index - 1][0]
        });

        // recurse into nested objects
        if (field.properties) {
          result.push(...this.buildMovedFieldsFromOrder(field.properties, key));
        }
      });

      return result;
    },
    updateSchema(reset) {
      let s = this.$refs.schemaTree[0];
      s.saveSchema();
      this.schema = s.schema;
      const url = "add_custom_schema"; // Flask route
      const key = Object.keys(this.schema)[0];

      // 🔧 Convert v-number-field → v-text-field with x-type=number
      if (this.addedFields && this.addedFields.length) {
        this.addedFields.forEach(f => {
          if (f.display === "v-number-field") {
            f.display = "v-text-field";
            f["x-type"] = "number";
          }
        });
      }

      if (this.editedFields && this.editedFields.length) {
        this.editedFields.forEach(f => {
          if (f.display === "v-number-field") {
            f.display = "v-text-field";
            f["x-type"] = "number";
          }
        });
      }

      let data = {
        key: this.schema[key].update_object || key, // name of schema file
        original_key: key,
        reset: reset,

        changes: {
          added: this.addedFields || [],
          edited: this.editedFields || [], // 🆕 NEW group
          hidden: this.hiddenFields || [],
          comboUpdates: this.comboUpdates || [],
          moved: this.buildMovedFieldsFromOrder(this.schema[key].properties || this.schema[key], key)
        },

        schema: this.schema
      };
      s.cleanupOrder(this.schema);

      this.loading = true;

      axios
        .post(this.serverURL + "/" + url, data, { withCredentials: true })
        .then(response => {
          this.loading = false;
          if (response.data.success) {
            console.log("✅ Schema file updated:", response.data.file);
            this.$toast?.success("Schema updated successfully!");
            this.$root.$emit("schema_updated");
          } else {
            console.warn("⚠️ Schema update error:", response.data.error);
            this.$toast?.error("Schema update failed!");
          }
        })
        .catch(error => {
          console.error("❌ Error updating schema:", error);
          this.$toast?.error("Failed to save schema file.");
        });
    },
    updateCollectionSchema() {
      var collections = fun.getObjectsKeys(this.schema, "collection", true);
      var that = this;
      collections.forEach(function(c) {
        var obj = fun.getObjectsByKey(that.schema, c);
        obj.forEach(o => {
          var objModel = fun.getObjectsByKey(that.model, c)[0];
          if (objModel) {
            var prop = o.properties;
            var propKey = Object.keys(prop)[0];
            var propVal = prop[propKey];
            var d = o.default;
            if (Array.isArray(d)) {
              d = d[0];
            }
            var defProp = {};

            defProp[d] = prop[d];

            Object.keys(prop).forEach(k => {
              if (k != d) {
                if (!objModel[k]) {
                  delete prop[k];
                } else {
                  prop[k].canDelete = true;
                }
              }
            });

            Object.keys(objModel).forEach(k => {
              if (!objModel[k]) {
                objModel[k] = {};
              }
              if (!prop[k]) {
                propVal.title = fun.capitalize(k);
                propVal.canDelete = true;
                prop[k] = propVal;
              } else {
                prop[k].title = fun.capitalize(k);
              }
            });
          }
        });
      });
    },
    getVBind(v) {
      var addProps = [
        "card",
        "draggable",
        "cols",
        "headerColor",
        "elevation",
        "displayOnClosedHeader",
        "noToolBar",
        "noTabs",
        "fields_excluded",
        "remoteSearch",
        "remoteSearchFields",
        "minSearchLength",
        "collapsible",
        "expandedIndex",
        "presetObject",
        "editedFields",
        "item",
        "fields",
        "sortValue",
        "addBtnTitle",
        "objectName",
        "objName",
        "dense",
        "cols",
        "fullCol",
        "fields_included",
        "fields_excluded",
        "step",
        "groups"
      ];
      var vBind = v["v-bind"];
      if (vBind) {
        addProps.forEach(p => {
          vBind[p] = v[p] || v["v-bind"] ? v["v-bind"][p] : "";
        });
      }
      if (vBind && vBind.mainTabs && !this.mainTabs && !this.noMainTabs) {
        this.mainTabs = vBind.mainTabs;
        this.defaultTab = vBind.defaultTab;
        // this.mainTab = 0;
      }

      if (v["x-type"] == "password") {
        if (!vBind) {
          vBind = {};
        }
        vBind["append-icon"] = "mdi-eye";
        // this.refs[key]
        // this.refs[this.key]["@click:append"] = showPassword();
      }

      return vBind || {};
    },
    closeDrawer(key) {
      this.drawerModel[key] = !this.drawerModel[key];
      this.drawer = !this.drawer;
    },
    customBtnClick(value, key) {
      if (value["v-bind"].customAction) {
        var r = this.model;
        eval(value["v-bind"].customAction);
        // var form = fun.getParentByProperty(this, "onDataChanged");
        console.log(r);
        // this.getInput(key);
        this.$emit("input", r[key]);
        this.getCalculatedFields();
      } else {
        this.$root.$emit("customBtnClick", { frm: this, btn: value.id });
      }
    },
    setReadOnly(k, r) {
      var that = this;
      that.schema[k]["v-bind"].readonly = r;
      that.componentKey = !that.componentKey;
      that.componentKeyChild = !that.componentKeyChild;
    },
    onBlur(key) {
      this.$root.$emit("elementBlur", {
        obj: this,
        el: key
      });
    },

    getInput(key, onValueChange, e) {
      var that = this;

      if (this.data_object && this.data_object.onInput && this.data_object.onInputKey == key) {
        this.data_object.onInput(this, key);
      }
      if (this.schema[key]["x-display"] == "v-textarea") {
        return;
      }
      // if (
      //   this.schema[key]["calculate"] ||
      //   this.schema[key]["calculateFn"] ||
      //   this.schema[key]["inCalculation"]
      // ) {

      // }
      if (!this.schema[key]["v-bind"] || !this.schema[key]["v-bind"].skipRecalculation) {
        this.getCalculatedFields();
      }

      // var form = fun.getParentByProperty(this, "onDataChanged");

      if (this.inLine) {
        this.$root.$emit("tableUpdated", this, true);
      }
      if (this.schema[key].updateFunction) {
        eval(this.schema[key].updateFunction);
      }
      if (this.onValueChange && e != "appendClick") {
        this.onValueChange(
          {
            model: that.model,
            key: key,
            obj: that
          },
          r => {
            // console.log(r);
          }
        );
      }
      if (
        this.schema[key]["v-bind"] &&
        this.schema[key]["v-bind"].onValueChange &&
        typeof this.schema[key]["v-bind"].onValueChange === "function"
      ) {
        this.schema[key]["v-bind"].onValueChange(
          {
            model: that.model,
            key: key,
            obj: that
          },
          r => {
            // console.log(r);
          }
        );
      }
      if (e == "appendClick") {
        if (this.schema[key]["x-type"] == "password") {
          // console.log(this.$refs[key][1]);
          var password = this.$refs[key][1];
          // this.schema[key]["x-type"] = "text";
          var showPassword = function() {
            if (password.type == "text") {
              password.type = "password";
              password.appendIcon = "mdi-eye";
            } else {
              password.type = "text";
              password.appendIcon = "mdi-eye-off";
            }
          };
          showPassword();
        } else {
          var m = that.model;
          var r = eval(onValueChange);
          this.$root.$emit("appendClick", { model: that.model, key: key });
          that.componentKey = !that.componentKey;
          that.componentKeyChild = !that.componentKeyChild;
        }

        console.log(r);
      }
      if (e == "change" && this.schema[key]["v-bind"] && this.schema[key]["v-bind"].onValueChange) {
        //
        this.$root.$emit("valueChanged", {
          model: that.model,
          key: key,
          obj: that
        });
      }
    },
    getOnChange(key) {
      var k = key.target.parentNode.getElementsByTagName("input")[0].getAttribute("k");
    },

    findTotal() {
      return fun.getObjectsByKey(this.data_object, "total")[0];
    },
    showColumns(value, key, schema) {
      if (this.show(value, key) && Object.keys(schema).length > 1) {
        return true;
      }
    },
    getComponents() {
      this.$refs.forEach(function(c) {
        // console.log(c);
      });
    },
    checkMobile() {
      return fun.isMobile();
    },
    checkWidth() {
      if (fun.isMobile()) {
        return 200;
      } else {
        return 400;
      }
    },
    getRule(r, label) {
      return fun.getRule(r, label);
    },

    sendValue(key) {
      this.$emit("input", this.$refs[key]);
    },
    move(key, after) {
      var keys = Object.keys(this.schema);
      var keyIndex = keys.indexOf(key);
      var nextKey;
      var element = document.getElementsByClassName(key)[0];
      var col = element.closest(".col");
      var row = col.closest(".row");

      var clonedSchema = fun.clone(this.schema);

      var clonedKeys = fun.clone(keys);

      if (after) {
        clonedKeys.splice(keyIndex, 1);
        clonedKeys.splice(keyIndex + 1, 0, key);
      } else {
        var prevLey = clonedKeys[keyIndex - 1];
        clonedKeys.splice(keyIndex - 1, 1);
        clonedKeys.splice(keyIndex, 0, prevLey);
      }

      keys.forEach(k => {
        delete this.schema[k];
      });
      clonedKeys.forEach(k => {
        this.schema[k] = clonedSchema[k];
      });
      console.log(clonedKeys);
      this.topKey = !this.topKey;
    },

    deleteRec(key) {
      var that = this;
      this.$root.$confirm
        .open("Delete", "Confirm deleting " + key.replaceAll("_", " ") + "?", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            delete that.schema[key];
            delete that.model[key];
            that.$emit("input", that.model);
            that.componentKey = !that.componentKey;
            that.componentKeyChild = !that.componentKeyChild;
          }
        });
    },

    show(value, key) {
      if (!value) {
        return false;
      }
      if (
        (value && !value["canDelete"]) ||
        !(
          (value && value["canDelete"] && !this.model[key]) ||
          (this.model && this.model[key] && Object.keys(this.model[key]).length === 0)
        )
      ) {
        return value["hidden"] ? value["inTableEdited"] : true;
      } else {
        return false;
      }
    },
    isPermitted(key) {
      if (!this.path) {
        this.path = this.getPath();
      }
      if (!this.permissions) {
        return true;
      }
      var objectsWithPermissions = this.permissions.filter(p => {
        return p.object_name;
      });
      objectsWithPermissions = objectsWithPermissions.filter(o => {
        return this.path.includes(o.object_name);
      });
      if (!objectsWithPermissions.length) {
        return true;
      }
      var permId = objectsWithPermissions[0].text.toLowerCase().replaceAll(" ", "_");
      var permKeys = this.permittedKeys.filter(k => {
        return k.split(".")[0] == permId;
      });
      var isP = true;
      permKeys.forEach(p => {
        var keys = p.split(".").splice(1)[0];
        if (keys.split(":").includes(key)) {
          isP = true;
        }
      });
      return isP;
    },
    isTab() {
      return this.parentSchema && this.parentSchema[this.parentKey] && this.parentSchema[this.parentKey]["tabs"];
    },
    getParentComponent() {
      var that = this;
      var comp = "div";

      if (this.schema) {
        if (this.isTab()) {
          comp = "v-tabs-items";

          return comp;
        } else {
          Object.keys(this.schema).forEach(function(k) {
            try {
              if (that.schema[k].cols) {
                comp = "v-row";
                return comp;
              }
            } catch (error) {
              //
            }
          });
          return comp;
        }
      } else {
        return comp;
      }
    },
    parentShow(key, parentKey, parentObject) {
      if (parentKey) {
        var parentProperties = null;
        var defaults = [];
        Object.keys(parentObject).forEach(function(p) {
          if (parentObject[p].collection) {
            parentProperties = parentObject[p].properties;
            defaults = parentObject[p].default;
          }
        });

        if (!parentProperties) {
          return true;
        }
        var ob = parentProperties[parentKey];
        if ((ob && ob.show) || defaults.includes(parentKey)) {
          return true;
        }
        var hasModel = this.model[key] && Object.keys(this.model[key]).length != 0;

        return hasModel;
      } else {
        return true;
      }
    },

    addRec(key, value, title, model, schema) {
      var newObj = {};
      var mKey = Object.keys(this.schema[key].properties)[0];
      var prop = this.schema[key].properties[mKey].properties;
      newObj.properties = prop;
      newObj.type = "object";
      newObj.title = title;
      newObj.newKey = value;
      newObj.canDelete = true;
      newObj.show = true;
      newObj.card = this.schema[key].properties[mKey].card;
      newObj.panel = this.schema[key].properties[mKey].panel;
      newObj.draggable = this.schema[key].properties[mKey].draggable;
      newObj.label_type = "menu_button";
      newObj.data_key = schema["name_key"];
      newObj.cols = this.schema[key].properties[mKey].cols;
      var parentProperties = this.schema[key].properties;
      var newObjName = "";
      try {
        newObjName = value.slice();
      } catch (error) {
        // console.log(error);
      }

      if (this.model[key]) {
        var that = this;
        var keys = Object.keys(this.model[key]);

        if (keys.indexOf(value) != -1) {
          var cntExist = 0;
          keys.forEach(function(k) {
            if (k.indexOf(value) != -1 && that.model[key] && Object.keys(that.model[key][value]).length) {
              if (!cntExist) {
                cntExist = 1;
              }
              cntExist += 1;
              newObjName = value + "_" + cntExist;
              newObj.title = title + " " + cntExist;
            }
          });
          // cntExist += 1;
        }
      } else {
        newObjName = value;
        newObj.title = title;
        this.model[key] = model || {};
      }
      parentProperties[newObjName] = newObj;

      this.model[key][newObjName] = model || {};
      this.model[key][newObjName][this.schema[key]["name_key"]] = value;

      Object.keys(prop).forEach(k => {
        if (prop[k].object_type) {
          this.model[key][newObjName][k] = {};
        }
      });
      if (this.data_object) {
        if (this.data_object.object_key && (this.tabs || this.tabs == 0)) {
          var tab = Object.keys(this.data_object.schema.properties[this.data_object.object_key].properties).length;
          this.$root.$emit("item-added", {
            key: this.data_object.object_key,
            model: this.model[key][newObjName],
            items: tab
          });
        }
        if (this.data_object.onAddRec) {
          this.data_object.onAddRec(this.model, newObjName);
        }

        this.$root.$emit("objAdded", {
          key: key,
          schema: this.data_object.schema,
          model: this.model[key][newObjName]
        });
      }
      this.componentKey = !this.componentKey;
      this.componentKeyChild = !this.componentKeyChild;
      this.topKey = !this.topKey;
      var parObj = fun.getObjectByKey(this.parentSchema, key);
      parObj.properties[value] = newObj;
      if (this.schema[key].submit) {
        this.submit();
      }
    },
    hide(value) {
      if ((this.mainTab || this.mainTab == 0) && (value.tab || value.tab == 0)) {
        if (this.mainTab != value.tab) {
          return true;
        }
      }
    },

    displayIf(value, parentKey, key) {
      var that = this;

      if (value["noCustomer"] && this.$root.customerId) {
        return false;
      }
      if (value["noHost"] && this.$root.isHost) {
        return false;
      }

      //check if element is in edit dialog of the table
      if (value.hideInTable) {
        if (fun.checkParentClass(this.$el, "edit-dialog-content")) return false;
      }

      if (this.parentSchema) {
        var hiddenFields = fun.getObjectsByKey(this.parentSchema, "hiddenFields");
        if (hiddenFields && hiddenFields.length) {
          // if (
          //   this.parentSchema &&
          //   this.parentSchema[value["v-if-parent-not-excluded"]] &&
          //   this.parentSchema[value["v-if-parent-not-excluded"]]["hiddenFields"]
          // ) {
          var skip = false;
          hiddenFields[0].forEach(h => {
            // if (key == "password") {
            //   console.log("psw");
            // }
            if (key) {
              h = h.split(".")[h.split(".").length - 1];
              if (
                h == key
                // &&
                // ((value.type == "object" && h == value.object_type) ||
                //   (value.type != "object" && !that.parentSchema[parentKey]))
                // that.model[h] &&
                // ((value.type == "object" && h == value.object_type) ||
                //   value.type != "object")
              ) {
                // console.log(value.object_type);
                // console.log(that.parentSchema);
                // console.log(parentKey);
                skip = true;
              }
            }
          });
          if (skip) {
            return false;
          }
          // }
          // console.log(value);
        }
      }
      if (value["v-if-parent"]) {
        console.log("parent found");
      }

      if (
        value["v-if-parent"] &&
        !this.parentModel &&
        (!this.parentSchema || !this.parentSchema[value["v-if-parent"]])
      ) {
        return false;
      }
      if (value["v-if-not-parent"] && (this.parentModel || this.hasParent)) {
        // if (value.tabName && this.mainTab == 0) {
        //   this.mainTab += 1;
        // }
        // console.log("parent found");
        if (value["v-if-not-parent"] == true) {
          return false;
        } else {
          if (this.parentModel[value["v-if-not-parent"]]) {
            return false;
          }
        }
      }
      if (
        (this.mainTabs &&
          this.mainTabs.length &&
          (this.mainTab || this.mainTab == 0) &&
          (value.tab || value.tab == 0)) ||
        (this.steppers && this.steppers.length)
      ) {
        var tabId = 0;
        if (this.steppers && this.steppers.length) {
          tabId = this.step - 1;
        } else {
          tabId = this.mainTabs[this.mainTab].tabId;
        }
        // if (this.defaultTab) {
        //   tabId = this.defaultTab;
        // }

        // this.mainTabs.forEach((t, i) => {
        //   if (t.noCustomer && t.default) {
        //     tabId = t.tabId;
        //     this.defaultTab = tabId;
        //     // this.changeTab(i);
        //   }
        // });

        if (
          (!Array.isArray(value.tab) && tabId != value.tab) ||
          (Array.isArray(value.tab) && !value.tab.includes(tabId))
        ) {
          return false;
        }
      }

      if (
        (value["v-if-not-parameter"] && this.model[value["v-if-not-parameter"]]) ||
        (value["v-if-not-parameter"] &&
          value["v-if-not-parameter"].name &&
          this.model[value["v-if-not-parameter"].name])
      ) {
        return false;
      }
      if (value["v-if-parameter-fn"]) {
        var r = this.model;
        var p = fun.getParentByProperty(this, value["parentProperty"]);
        var mP = fun.getParentByProperty(this, value["myProperty"]);
        // if (value["myProperty"]) {
        //   console.log(value["myProperty"]);
        // }
        var pM = this.parentModel;

        try {
          return eval(value["v-if-parameter-fn"]);
        } catch (error) {
          //
        }
      }
      var par = value["v-if-parameter"] ? value["v-if-parameter"].name || value["v-if-parameter"] : "";
      if (value["v-if-value"] || value["v-if-parent"]) {
        var prop = par.split(".");
        var obj = this.model;
        var val = null;
        if (prop.length == 1) {
          val = this.model[par];
        } else {
          for (let i = 0; i < prop.length; i++) {
            obj = obj[prop[i]];
            if (typeof obj != "object") {
              val = obj;
              break;
            }
          }
        }

        var show =
          fun.toArrayOfString(value["v-if-value"]).includes(val) ||
          value["v-if-value"] == val ||
          (value["v-if-value"].toString().indexOf("undefined") > -1 && !val && !value["v-if-parent"]) ||
          (parentKey && value["v-if-parent"] && value["v-if-parent"] == parentKey) ||
          (this.parentModel &&
            value["v-if-parent"] &&
            this.parentModel[value["v-if-parent"]] &&
            this.parentModel[value["v-if-parent"]].length);
        return show;
      }
      if (value["v-if-parameter"] && !value["v-if-value"] && !value["v-if-not-value"]) {
        var params = par.split(",");
        var incl = false;
        var m = that.model;
        params.forEach(p => {
          var par = p.split(".")[0];

          if (
            (that.model[par] && that.model[par].length) ||
            that.model[par] == true ||
            (typeof that.model == "object" && p.split(".").length > 1 && fun.deepFind(that.model, p.split(".").shift()))
          ) {
            incl = true;
          }
        });
        return incl;
      }
      if (value["v-if-not-value"]) {
        var arr = fun.toArrayOfString(value["v-if-not-value"]);
        var i = fun.toArrayOfString(value["v-if-not-value"]);
        // console.log(i);
        // par = value["v-if-parameter"].name || value["v-if-parameter"];
        // if (value["v-if-not-value"] == "rate")
        // {
        //   console.log("found")
        // }
        var parValue = value["v-if-parameter"].name || value["v-if-parameter"];
        let display =
          value["v-if-not-value"] == "true"
            ? false
            : !fun.toArrayOfString(value["v-if-not-value"]).includes(this.model[par]?.toString().toLowerCase()) &&
              this.model[parValue] != value["v-if-not-value"];
        return display;
      }

      return true;
    },
    updateProperties() {
      var that = this;
      console.log(this.schema);
    },
    displayComponent(value, parentKey, key) {
      // console.log(key);
      if (key == "pickup_date_range") {
        // console.log(value);
      }
      var p = this.isPermitted(key);
      if (!p) {
        return false;
      }
      if (parentKey == "estimate_charges") {
        return false;
      }
      if (value["v-if-parameter"] || value["v-if-parent"]) {
        return this.displayIf(value, parentKey, key);
      } else if (this.isExpandRow) {
        return value["in_expand"];
      } else {
        return (!value["hidden"] || value["inTableEdited"]) && (value["type"] == "string" || value["x-display"]);
      }
    },
    displayParent() {
      if (this.tabChanging) {
        return false;
      }
      if (!this.parentSchema && !this.parentKey) {
        return true;
      } else {
        if (this.parentSchema && this.parentKey && this.parentSchema[this.parentKey]) {
          return !this.parentSchema[this.parentKey].hidden;
        } else {
          return true;
        }
      }
    },
    getCurrentDateTime() {
      return fun.getCurrentDateTime(true);
    },
    getCurrentUser() {
      return this.$root.user_email;
    },
    getCurrentDate() {
      return fun.getCurrentDateTime();
    },
    getNextNumber(k) {
      // console.log(k);

      return parseInt(Math.random() * 1000000);
    },
    calculateTitle(t, key) {
      var parentKey = this.parentKey;
      var r = this.model;
      var rec = r[key];

      // console.log(parentKey, r);
      try {
        return eval(t);
      } catch (error) {
        return "";
      }
    },
    getReadOnly(k) {
      var that = this;
      var formContainer = fun.getParentsByProperty(this, "formContainer")[0];

      if (formContainer && formContainer.readOnly) {
        return true;
      }
      if (k.includes("status") && this.disableStatusChange()) {
        return true;
      }

      var readonly = false;
      // if(!readonly){
      //   return true
      // }
      var readOnlys = {};
      var r = that.model;
      var p = that.model;
      if (this.schema[k]["v-bind"] && this.schema[k]["v-bind"].readonly) return this.schema[k]["v-bind"].readonly;
      if (this.schema[k]["v-bind"] && this.schema[k]["v-bind"].readOnlyFormula)
        try {
          return eval(this.schema[k]["v-bind"].readOnlyFormula);
        } catch (error) {
          //
        }

      if (that.parentSchemaObject) {
        // Object.keys(that.parentSchemaObject).forEach(function(k) {
        if (
          that.parentSchemaObject[k] &&
          that.parentSchemaObject[k]["v-bind"] &&
          that.parentSchemaObject[k]["v-bind"].readOnlyFormula
        ) {
          var readOnlyFormula = that.parentSchemaObject[k]["v-bind"].readOnlyFormula;
          if (readOnlyFormula) {
            return eval(readOnlyFormula);
          } else {
            return that.parentSchemaObject[k]["v-bind"].readonly;
          }
          // readOnlys.k = readonly;
        }
        // });
      }
      // return readOnlys[t];
    },
    getModelValue(key, value) {
      const current = this.model[key];

      // ✅ If it's already valid (not null/undefined), just return it
      if (current !== null && current !== undefined) return current;

      // ✅ Handle non-text components that expect arrays or objects
      const complexDisplays = ["d-table", "v-charge", "d-iterator", "v-data-time-line", "v-collapsible"];

      if (complexDisplays.includes(value["x-display"])) return [];

      // ✅ Default fallback for text-like fields
      return "";
    },
    disableStatusChange() {
      this.currentUser = this.$root.store.userData.email;
      var permittedActions = this.$root.store.permittedActions;
      var readOnly = false;
      if (permittedActions) {
        permittedActions.forEach(a => {
          if (a.cannot_change_status && !this.$root.roles.some(role => role.toLowerCase() === "admin")) {
            readOnly = true;
          }
        });
      }
      return readOnly;
    },
    formatDateTime(d) {
      return fun.formatDateTime(d);
    },
    getCalculatedFields(t) {
      var that = this;
      var portal_id = this.$root.portal_id;
      var formatDate = fun.formatDate;
      var modifyDate = fun.modifyDate;
      var getParentByProperty = fun.getParentByProperty;

      var getSum = function(a) {
        return fun.getSum(a);
      };
      var sum = function(r, formula) {
        return fun.sum(r, formula);
      };
      var getNumber = function(n) {
        return fun.getNumber(n);
      };
      var getCount = function(n) {
        return fun.getCount(n);
      };
      var today = function() {
        return formatDate(new Date());
      };
      var convertToEuropean = fun.convertToEuropean;
      var dateRange = function(date, d, business) {
        if (!date) {
          return "";
        }
        var firstDate = fun.fixDate(new Date(date));

        let nextDay = fun.fixDate(new Date(date));
        if (!business) {
          nextDay = nextDay.addDays(d);
        } else {
          nextDay = fun.addBusinessDays(nextDay, d);
          // nextDay = nextDay.addDays(bDays);
        }

        return formatDate(firstDate) + "-" + formatDate(nextDay);
      };
      // console.log(getSum, sum);
      var schema = this.schema;
      if (this.inLine) {
        schema = this.parentSchema || {};
      }
      var filter = null;
      if (t && t.filterItems) {
        filter = t.filterItems[t.currentFilter - 1];
      }
      if (schema) {
        var r = that.model;
        var p = that.parentModel;
        var pModel = that.parentModel;
        Object.keys(schema).forEach(function(k) {
          if (schema[k] && schema[k].calculate) {
            // console.log(r);
            try {
              if (that.data_object) {
                var addMod = that.data_object.additionalModel;
              }

              if (!schema[k].noReturnOnCalculate) {
                that.model[k] = eval(schema[k].calculate);
              } else {
                eval(schema[k].calculate);
              }

              // console.log(k, that.model[k]);
            } catch (e) {
              // if (e instanceof SyntaxError) {
              // console.log(e.message);
              // }
            }

            if (schema[k].calculateFn) {
              that.model[k] = schema[k].calculateFn();
            }
          }

          if (!that.model[k] && schema[k]?.default_value?.calc && that.displayIf(that.schema[k], that.parentKey, k)) {
            //&& that.displayIf(that.schema[k], that.parentKey, k)

            that.model[k] = eval(that.schema[k].default_value.calc);
          }
        });
      }
    },
    // getVBind(value) {
    //   return value[`x-display`] == "d-table"
    //     ? {
    //         ...value[`v-bind`],
    //         ...value["table_properties"]["schema"]["v-bind"],
    //       }
    //     : value[`v-bind`];
    // },

    getModel(key) {
      // if (key == "included_stops") {
      //   console.log("included_stops");
      // }
      var model = this.model;
      var m = model;
      if (model && model[key]) {
        m = model[key];
      } else {
        m = {};
        m[key] = {};
        // if (this.schema[key].default_value) {
        //   m[key] = this.schema[key].default_value;
        // }
      }

      // var modelArray = [];
      // Object.keys(m).forEach(function(k) {
      //   modelArray.push(m[k]);
      // });

      // return modelArray;
      return m;
    },
    capitalize(text) {
      return fun.capitalize(text);
    },

    enableDrag() {
      var that = this;
      document.addEventListener("mousedown", e => {
        if (e.target && Array.from(e.target.parentNode.classList).includes("drag-header")) {
          that.dragMouseDown(e);
        }
      });
    },
    dragMouseDown: function(e) {
      // e.preventDefault();
      this.draggedEl = e.target.closest(".draggable");
      const w = this.draggedEl.offsetWidth + "px";
      const l = this.draggedEl.offsetLeft;
      var contLeft = document.getElementsByClassName("v-main__wrap")[0].offsetLeft;
      this.l = l + contLeft;
      this.draggedEl.style.position = "absolute";
      this.draggedEl = e.target.closest(".draggable");
      this.draggedEl.style.width = w;

      document.onmousemove = this.elementDrag;

      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function(event) {
      event.preventDefault();
      // const l = this.draggedEl.offsetLeft;

      this.positions.movementX = event.clientX;
      this.positions.movementY = event.clientY; //#endregion;
      this.positions.clientX = event.clientX - this.l;

      this.draggedEl.style.left = this.positions.clientX + "px";
      this.draggedEl.style.top = this.positions.movementY + "px";
      // var column = this.getCurrentColumn(event);
    },
    closeDragElement(e) {
      document.onmouseup = null;
      document.onmousemove = null;
      this.draggedEl.style.position = "static";
      var parentContainer = this.draggedEl.closest("row");

      if (this.parentEl && this.draggedEl) {
        console.log("close");
      }
    },
    dragEnd(p) {
      console.log(p);
    },
    roles() {
      return this.$store.getters["auth/user"].roles || [];
    },
    getColor(color, key) {
      try {
        return eval(color);
      } catch (error) {
        return "#000";
      }
    },
    isCollection() {
      var obj = fun.getObjects(this.parentSchema, "collection", true);
      if (obj.length) {
        return obj[0].object_type;
      }
    },
    getPath() {
      var path = window.location.href.split("/");
      var hashIndex = window.location.href.split("/").indexOf("#") + 1;
      return path.splice(hashIndex);
    },

    openOnDemand() {
      this.$router.push({
        name: "object-on-demand",
        params: {
          objectName: this.k,
          objectId: this.vModel
        }
      });
    },
    getLinkedId(k) {
      if (this.model[k]) {
        this.linkedSearchModel = this.model[k]["_id"] || 0;
      }
    },

    removePropertyBasedOnTab(schema) {
      if (this.mainTabs == undefined) {
        return schema;
      }
      var currentTabId = 0;
      try {
        currentTabId = this.defaultTab || this.mainTabs[this.mainTab || 0].tabId;
      } catch (error) {
        //
      }

      Object.keys(schema).forEach(outerKey => {
        let value = schema[outerKey];
        let shouldDelete = false;
        if ((typeof value.tab === "string" || typeof value.tab === "number") && value.tab !== currentTabId) {
          shouldDelete = true;
        }
        // Check if tab is an array and doesn't contain currentTabId
        else if (Array.isArray(value.tab) && !value.tab.includes(currentTabId)) {
          shouldDelete = true;
        }

        // If either condition is met, delete the property
        if (shouldDelete) {
          // this.$delete(schema[outerKey]);
          delete schema[outerKey];
        }
      });

      // for (let outerKey in schema) {
      //   if (
      //     Object.prototype.hasOwnProperty.call(schema, outerKey) &&
      //     schema[outerKey].properties
      //   ) {
      //     // for (let innerKey in schema[outerKey].properties) {
      //     schema[outerKey].forEach((value) => {
      //       let shouldDelete = false;

      //       // Check if tab is a string and doesn't match currentTabId
      //       if (
      //         (typeof value.tab === "string" ||
      //           typeof value.tab === "number") &&
      //         value.tab !== currentTabId
      //       ) {
      //         shouldDelete = true;
      //       }
      //       // Check if tab is an array and doesn't contain currentTabId
      //       else if (
      //         Array.isArray(value.tab) &&
      //         !value.tab.includes(currentTabId)
      //       ) {
      //         shouldDelete = true;
      //       }

      //       // If either condition is met, delete the property
      //       if (shouldDelete) {
      //         this.$delete(schema[outerKey]);
      //       }
      //     });

      //     // let value = schema[outerKey].properties[innerKey];

      //     // }
      //   }
      // }
      return schema;
    }
    // Your other methods here
  },

  watch: {
    // model: {
    //   immediate: true,
    //   handler() {
    //     var that = this;
    //     if (!this.schema || this.openedObjectOnDemand) return;
    //     if (this.formModel !== this.model) return;

    //     for (const key in that.schema) {
    //       const value = that.schema[key];
    //       if (value?.["x-display"] === "object-on-demand" && this.model?.[key]) {
    //         this.openedObjectOnDemand = true;
    //         this.$router.push({
    //           name: "object-on-demand",
    //           params: {
    //             objectName: value.objectName || key,
    //             objectId: that.model[key]
    //           }
    //         });
    //         break;
    //       }
    //     }
    //   }
    // },
    mainTab() {
      if (this.mainTab || this.mainTab == 0) {
        this.$root.$emit("mainTabChanged", this);
      }
      if (!this.noCache) {
        this.restoreSchema();
      }
    }
  },
  computed: {
    // canEditForm() {
    //   var canEdit = false;
    //   this.$root.store?.permittedActions.forEach((a) => {
    //     if (a.can_edit_form) {
    //       canEdit = true;
    //     }
    //   });
    //   return canEdit;
    // },
    addCollectionToSchema() {
      if (this.data_object) {
        if (this.noCache) {
          return this.schema;
        }
        var objName = this.data_object.objectName;

        var storedSchema;
        try {
          if (objName) {
            storedSchema = JSON.parse(localStorage.getItem(objName));
          }
        } catch (error) {
          //
        }
      }

      if (!this.parentKey && !storedSchema && this.schema && !this.hasParent) {
        localStorage.setItem(objName, JSON.stringify(this.schema));
      }
      var collectionSchema;
      if (!this.hasParent) {
        collectionSchema = this.schema;
      } else {
        collectionSchema = fun.clone(this.schema);
      }

      var sortByKey = false;
      try {
        if (this.parentSchema && this.parentSchema[this.parentKey] && this.parentSchema[this.parentKey].sortedKey) {
          sortByKey = true;
        }
      } catch (error) {
        //
      }

      try {
        if (this.model[this.isCollection()]) {
          // collectionSchema = collectionSchema[this.isCollection()];
          var mainKey = Object.keys(collectionSchema[this.isCollection()].properties)[0];
          Object.keys(this.model[this.isCollection()]).forEach(k => {
            if (!collectionSchema[this.isCollection()].properties[k]) {
              collectionSchema[this.isCollection()].properties[k] =
                collectionSchema[this.isCollection()].properties[mainKey];
            }
          });
          // collectionSchema = collectionSchema.properties;
        }
      } catch (error) {
        //
      }
      collectionSchema = this.removePropertyBasedOnTab(collectionSchema);
      if (sortByKey) {
        collectionSchema = fun.sortObjectByKey(collectionSchema, "title");
      }
      if (this.fullCol) {
        try {
          var properties = fun.getObjectByKey(collectionSchema, "properties");
          Object.keys(properties).forEach(p => {
            if (properties[p].cols) {
              properties[p].cols = 12;
            }
          });
        } catch (error) {
          //
        }
      }

      return collectionSchema;
    },
    schemaTabs() {
      return this.mainTabs;
    },
    editSchema() {
      let e = {};
      if (this.topObject) {
        e[this.topObject] = {};
        e[this.topObject].type = "object";
        e[this.topObject].properties = this.schema;
      } else {
        e = this.schema;
      }
      return e;
    },
    parentObject() {
      var schema = this.schema;
      var m = this.model;
      if (!m) {
        m = {};
      }
      if (!Object.keys(m).length && schema) {
        Object.keys(schema).forEach(function(k) {
          if (schema[k] && schema[k]["type"] == "object") {
            m[k] = {};
          }
        });
      }
      return m;
    }
  },
  created() {},
  mounted() {
    var that = this;
    // if (this.schema[this.k]["x-display"] == "object-on-demand") {
    //   this.openOnDemand();
    // }

    // console.log(this.$root.store?.permittedActions);
    if (!this.parentSchema) {
      var canEdit = false;
      this.$root.store?.permittedActions?.forEach(a => {
        if (a.can_edit_form) {
          canEdit = true;
        }
      });
      this.canEditForm = canEdit;
    }

    this.$root.$on("simulate-typing", ({ field, value }) => {
      if (this.$refs[field]) {
        this.$refs[field].$el.querySelector("input").value = value;
        this.form[field] = value; // keep v-model updated
      }
    });
    // var removeAllEventListenersFromElement = function(element) {
    //   // Clone the element
    //   const newElement = element.cloneNode(true);

    //   // Replace the original element with the clone (without the event listeners)
    //   element.parentNode.replaceChild(newElement, element);
    // };
    // var removeAllEventListenersFromAllInputs = function() {
    //   const inputs = document.querySelectorAll("input");

    //   inputs.forEach((input) => {
    //     removeAllEventListenersFromElement(input);
    //   });
    // };
    // removeAllEventListenersFromAllInputs();

    this.$root.$on("recalculateFields", m => {
      that.getCalculatedFields(m);
    });
    this.getCalculatedFields();
    if (localStorage.getItem("menuItems")) {
      this.permissions = JSON.parse(localStorage.getItem("menuItems"));
    }
    if (!this.schema) {
      return;
    }
    this.$root.$on("dialogClose", () => {
      that.linkedSearch = 1;
    });
    try {
      this.updateCollectionSchema();
    } catch (error) {
      console.log(error);
    }

    this.updateDefaultModel();

    Object.keys(this.schema).forEach(k => {
      if (that.schema[k]) {
        if (that.schema[k].drawer) {
          that.drawer[k] = false;
        } else {
          that.drawer[k] = true;
        }
      }
    });

    this.$root.$on("drawerChanged", function(drawer) {
      that.drawer = {};
      Object.keys(that.schema).forEach(k => {
        if (that.schema[k].drawer) {
          that.drawer[k] = false;
        } else {
          that.drawer[k] = true;
        }
      });

      Object.keys(drawer).forEach(k => {
        that.drawer[k] = drawer[k];
      });
      that.drawerChanged = !that.drawerChanged;
    });

    if (this.schema) {
      Object.keys(this.schema).forEach(function(k) {
        if (that.schema[k]) {
          try {
            that.schema[k]["show"] = that.show(that.schema[k], k);
          } catch (error) {
            //
          }

          if (that.schema[k].default_value) {
            if (!that.model[k]) {
              if (that.schema[k].default_value.value) {
                that.model[k] = that.schema[k].default_value.value;
              }
              if (that.schema[k].default_value.function) {
                try {
                  that.model[k] = that[that.schema[k].default_value.function](k);
                } catch (error) {
                  //
                }
              }
              if (that.schema[k].default_value.calc && that.displayIf(that.schema[k], that.parentKey, k)) {
                //)
                var p = that.parModel;
                var r = that.model;
                var pModel = that.parentModel;

                that.model[k] = eval(that.schema[k].default_value.calc);
              }
            }
          }

          if (that.schema[k]["v-bind"]) {
            var vBind = that.schema[k]["v-bind"];
            if (vBind.capitalizeText && vBind.items && vBind.items.length && typeof vBind.items[0] != "object") {
              vBind.items = fun.capitalizeItems(vBind.items);
            }
          }
        }

        // if (
        //   (that.mainTab || that.mainTab == 0) &&
        //   (that.schema[k].tab || that.schema[k].tab == 0)
        // ) {
        //   // if (this.mainTab != value.tab) {
        //   that.schema[k]["hidden"] = that.mainTab != that.schema[k].tab;
        //   // return true;
        //   // }
        // }
      });
      if (that.onLoadComponent) {
        that.onLoadComponent(that);
      }
    }
    if (this.mainTabs) {
      let index = this.mainTabs.findIndex(item => !this.displayIf(item));

      if (index == 0) {
        // Remove the item from its current position
        let item = this.mainTabs.splice(index, 1)[0];

        // Add the item to the end of the array
        this.mainTabs.push(item);
      }

      this.mainTabsClone = fun.clone(this.mainTabs);
    }
    console.log("FORM REGISTERED");
    window.__ACTIVE_FORM__ = this;
  }
};
</script>
<style>
/* ================================
   GLOBAL V-INPUT SKIN
================================ */

/* spacing */
.v-input {
  margin: 1px 0;
}

/* main control box */
.v-input .v-input__control {
  /* background: #f9fbfd; */
  /* border: 1px solid #e6edf5; */
  border-radius: 6px;
  padding: 2px 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

/* hover */
.v-input:hover .v-input__control {
  /* border-color: #b8d2f0;
  background: #ffffff; */
}

/* focus */
.v-input.v-input--is-focused .v-input__control {
  border-color: #4a90e2;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.15);
}

/* input text */
.v-input input,
.v-input textarea {
  font-size: 0.9rem;
  color: #2c3e50;
}

/* label */
.v-input .v-label {
  font-size: 0.9rem;
  /* text-transform: uppercase; */
  letter-spacing: 0.04em;
  font-weight: 500;
  color: #6b7c93;
}

/* error state */
.v-input.v-input--has-error .v-input__control {
  border-color: #e74c3c;
  background: #fff5f5;
}

/* error message */
.v-input .v-messages__message {
  font-size: 0.75rem;
  margin-top: 4px;
}

/* disabled */
.v-input.v-input--is-disabled .v-input__control {
  background: #f1f4f8;
  border-color: #dfe6ef;
}

/* readonly */
.v-input.v-input--is-readonly .v-input__control {
  background: #f7f9fc;
}

/* dense inputs (v-text-field dense, etc.) */
.v-input.v-input--dense .v-input__control {
  padding: 4px 8px;
}

/* solo / outlined compatibility */
.v-input.v-text-field--outlined .v-input__control,
.v-input.v-text-field--solo .v-input__control {
  border-radius: 6px;
}
/* ================================
   GLOBAL V-BTN SKIN
================================ */

.v-btn {
  min-height: 28px;
  padding: 0 10px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-radius: 6px;
}

/* default text color */
.v-btn .v-btn__content {
  line-height: 1;
}

/* hover */
.v-btn:not(.v-btn--disabled):hover {
  filter: brightness(1.05);
}

/* focus */
.v-btn.v-btn--active,
.v-btn:focus-visible {
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.25);
}

/* disabled */
.v-btn.v-btn--disabled {
  opacity: 0.45;
}

/* dense buttons */
.v-btn.v-btn--dense {
  min-height: 24px;
  padding: 0 8px;
  font-size: 0.75rem;
}

/* icon-only buttons */
.v-btn.v-btn--icon {
  min-width: 28px;
  width: 28px;
  height: 28px;
  padding: 0;
}

/* icon-only dense */
.v-btn.v-btn--icon.v-btn--dense {
  width: 24px;
  height: 24px;
}

/* text buttons */
.v-btn.v-btn--text {
  padding: 0 6px;
}

/* outlined buttons */
.v-btn.v-btn--outlined {
  border-width: 1px;
}
/* ================================
   GLOBAL V-INPUT SKIN — DARK MODE
================================ */

.theme--dark .v-input {
  margin: 1px 0;
}

/* main control box */
.theme--dark .v-input .v-input__control {
  background: initial;
  border-radius: 6px;
  padding: 2px 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

/* focus */
.theme--dark .v-input.v-input--is-focused .v-input__control {
  background: #242b33;
  box-shadow: 0 0 0 2px rgba(106, 169, 255, 0.25);
}

/* input text */
.theme--dark .v-input input,
.theme--dark .v-input textarea {
  font-size: 0.9rem;
  color: #e3e9f1;
}

/* label */
.theme--dark .v-input .v-label {
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  font-weight: 500;
  color: #a6b0c0;
}

/* error state */
.theme--dark .v-input.v-input--has-error .v-input__control {
  background: #2a1f22;
}

/* error message */
.theme--dark .v-input .v-messages__message {
  font-size: 0.75rem;
  margin-top: 4px;
  color: #ff8a80;
}

/* disabled */
.theme--dark .v-input.v-input--is-disabled .v-input__control {
  background: #1a1f25;
  opacity: 0.6;
}

/* readonly */
.theme--dark .v-input.v-input--is-readonly .v-input__control {
  background: #1d232a;
}

/* dense inputs */
.theme--dark .v-input.v-input--dense .v-input__control {
  padding: 4px 8px;
}

/* solo / outlined compatibility */
.theme--dark .v-input.v-text-field--outlined .v-input__control,
.theme--dark .v-input.v-text-field--solo .v-input__control {
  border-radius: 6px;
}

/* ================================
   GLOBAL V-BTN SKIN — DARK MODE
================================ */

.theme--dark .v-btn {
  min-height: 28px;
  padding: 0 10px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-radius: 6px;
}

/* default text */
.theme--dark .v-btn .v-btn__content {
  line-height: 1;
  color: #e3e9f1;
}

/* hover */
.theme--dark .v-btn:not(.v-btn--disabled):hover {
  filter: brightness(1.15);
}

/* focus */
.theme--dark .v-btn.v-btn--active,
.theme--dark .v-btn:focus-visible {
  box-shadow: 0 0 0 2px rgba(106, 169, 255, 0.35);
}

/* disabled */
.theme--dark .v-btn.v-btn--disabled {
  opacity: 0.4;
}

/* dense buttons */
.theme--dark .v-btn.v-btn--dense {
  min-height: 24px;
  padding: 0 8px;
  font-size: 0.75rem;
}

/* icon-only buttons */
.theme--dark .v-btn.v-btn--icon {
  min-width: 28px;
  width: 28px;
  height: 28px;
  padding: 0;
}

/* icon-only dense */
.theme--dark .v-btn.v-btn--icon.v-btn--dense {
  width: 24px;
  height: 24px;
}

/* text buttons */
.theme--dark .v-btn.v-btn--text {
  padding: 0 6px;
}

/* outlined buttons */
.theme--dark .v-btn.v-btn--outlined {
  border-width: 1px;
}

.blurred {
  filter: blur(4px);
  pointer-events: none;
}

.schema-container {
  position: relative;
  transition: filter 0.2s ease;
}
/* ================================
   GLOBAL V-CARD SKIN — LIGHT MODE
================================ */

.v-card {
  border-radius: 8px;
  background-color: #ffffff;
  color: #2c3e50;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

/* card title */
.v-card .v-card__title {
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #2c3e50;
  padding: 10px 14px;
}

/* card subtitle */
.v-card .v-card__subtitle {
  font-size: 0.75rem;
  color: #6b7c93;
  padding: 0 14px 8px;
}

/* card text / content */
.v-card .v-card__text {
  font-size: 0.9rem;
  color: #2c3e50;
  padding: 10px 14px;
}

/* card actions */
.v-card .v-card__actions {
  padding: 6px 10px;
  border-top: 1px solid #eef2f6;
}

/* outlined cards */
.v-card.v-card--outlined {
  box-shadow: none;
  border: 1px solid #e6edf5;
}

/* flat cards */
.v-card.v-card--flat {
  box-shadow: none;
  background-color: transparent;
}

/* hover lift (optional, subtle) */
.v-card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06), 0 6px 16px rgba(0, 0, 0, 0.08);
}

/* ================================
   GLOBAL V-CARD SKIN — DARK MODE
================================ */

.theme--dark .v-card {
  border-radius: 8px;
  background-color: #1f252c;
  color: #e3e9f1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5), 0 6px 16px rgba(0, 0, 0, 0.6);
}

/* card title */
.theme--dark .v-card .v-card__title {
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #e3e9f1;
  padding: 10px 14px;
}

/* card subtitle */
.theme--dark .v-card .v-card__subtitle {
  font-size: 0.75rem;
  color: #a6b0c0;
  padding: 0 14px 8px;
}

/* card text / content */
.theme--dark .v-card .v-card__text {
  font-size: 0.9rem;
  color: #e3e9f1;
  padding: 10px 14px;
}

/* card actions */
.theme--dark .v-card .v-card__actions {
  padding: 6px 10px;
  border-top: 1px solid #2a3442;
}

/* outlined cards */
.theme--dark .v-card.v-card--outlined {
  box-shadow: none;
  border: 1px solid #2a3442;
}

/* flat cards */
.theme--dark .v-card.v-card--flat {
  box-shadow: none;
  background-color: transparent;
}

/* hover lift */
.theme--dark .v-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.65), 0 10px 24px rgba(0, 0, 0, 0.75);
}

.blur-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  background-color: rgba(255, 255, 255, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.edit-form-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}

.value-title {
  font-weight: bold;
}

.value-text {
  text-decoration: underline;
  color: blue;
  font-size: large;
}

.v-stepper {
  border: none !important;
  box-shadow: none !important;
}

.v-stepper__content {
  background-color: transparent !important;
}

@media only screen and (max-width: 600px) {
  .main-tabs {
    margin-left: -25px;
  }

  .v-expansion-panel-content__wrap,
  .row,
  .v-card__text,
  .v-application,
  .container {
    padding-left: 2px !important;
    padding-right: 0 !important;
  }

  .col {
    padding-right: 3px !important;
    padding-left: 0px !important;
  }
}
</style>
